import { SvgIcon } from '@mui/material';
import type React from 'react';
import type { IconProps } from './types.js';

const Workflow: React.FC<IconProps> = (props) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M11 6.08296C8.16229 6.55904 6 9.027 6 12C6 14.973 8.16229 17.441 11 17.917V22H13V17.917C15.8377 17.441 18 14.973 18 12C18 9.027 15.8377 6.55904 13 6.08296V2H11V6.08296ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z" />
  </SvgIcon>
);

export default Workflow;
